import "./scss/styles.scss";
import React from "react";
import { useIntl } from "react-intl";
import { Button } from "@components/atoms";
import { commonMessages } from "@temp/intl";
export var AlertReusableDialog = function AlertReusableDialog(_ref) {
  var AlertDescription = _ref.AlertDescription,
      AlertTitle = _ref.AlertTitle,
      hideModal = _ref.hideModal;
  var intl = useIntl();
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "showContainer"
  }), React.createElement("div", {
    className: "showContainer__data"
  }, React.createElement("div", {
    className: "showContainer__data__close"
  }, React.createElement("p", null, AlertTitle)), React.createElement("div", {
    className: "showContainer__data__content showContainer__data__content--first"
  }), React.createElement("div", {
    className: "showContainer__data__content showContainer__data__content--value showContainer__data__content--first showContainer__data__content--last"
  }, React.createElement("p", null, AlertDescription)), React.createElement("div", {
    className: "showContainer__data__footer"
  }, React.createElement(Button, {
    type: "button",
    testingContext: "",
    onClick: hideModal
  }, React.createElement("p", null, intl.formatMessage(commonMessages.accept))))));
};
export default AlertReusableDialog;